import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
// import { messaging, getToken } from "../../firebase/firebaseConfig";
// import zIndex from "@mui/material/styles/zIndex";
import Loader from "../../Loader/Loader";
import invalidimg from "../../Popupimage/invalid.jpeg";
import SuccessImg from "../../Popupimage/success4.webp";
import somethingwrong from "../../Popupimage/somewent.jpeg";

function Header() {
  const [userToken, setUserToken] = useState(null);
  const [profile, setProfile] = useState({});
  const [profiletoken, setProfileToken] = useState(true);
  const [modalState, setModalState] = useState(null);
  const [responsePop, setResponsivepop] = useState(true);
  const [LoaderFun, setLoaderFun] = useState(false);
  const [CountStatus, setContStatus] = useState({});
  const [NotificationResult, setNotificationData] = useState([]);
  const [submenuPopup, setsubmenuPopup] = useState(false);
  const [notificationmenuPopup, setNotificationmenuPopup] = useState(false);
  const [showNotificationcount, setNotificationCount] = useState(true);
  const [loadingClearAll, setLoadingClearAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notiLoad, setNotiLoad] = useState(false);
  const [notifyDelete, setNotifyDelete] = useState(false);
  const [delId, setDelId] = useState("");
  const [delType, setDelType] = useState();
  const navigate = useNavigate();
  const useractive = useLocation();
  console.log("url-====", useractive.pathname);
  const hostURLs = [
    "/hosthomes",
    // "/aboutus",
    "/my-listing",
    "/earning",
    // "/contact",
    "/booking_details",
    "/Manage_parking",
    "/add_parking",
  ];

  const guestURLs = [
    "/",
    "/parking",
    "/parking/:id",
    "/parking/booking",
    "/Paymentstripe",
    "/ownerbooking",
    "/Favorater",
  ];
  //  Notification Section Operation
  const handleNotiifcation = () => {
    setNotificationmenuPopup(!notificationmenuPopup);
    setNotificationCount(false);
    NotificationData();
  };

  const CountSatatus = async () => {
    try {
      const token = localStorage.getItem("parqd_token");
      if (!token) return;
      const response = await axios.get("notification-status", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("counnnt---------", response.data);
      setContStatus(response.data);
    } catch (error) {
      console.log("error--hhhh", error);
    }
  };

  const NotificationData = async () => {
    setNotiLoad(true);
    try {
      const token = localStorage.getItem("parqd_token");
      if (!token) return;
      const response = await axios.get("get-notification", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("noti---------", response.data.notification);
      setNotificationData(response.data.notification);
    } catch (error) {
      console.log("error--hhhh ---noti", error);
    }
    setNotiLoad(false);
  };

  // End Notification Section Opertion

  const hostUser = parseInt(localStorage.getItem("host_user"), 10);

  const token = localStorage.getItem("parqd_token");

  useEffect(() => {
    if (modalState === "delete" || modalState === "logout") {
      document.body.classList.add("modal-open");

      // Create and append backdrop
      const backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade in";
      document.body.appendChild(backdrop);

      return () => {
        closeModal();
      };
    } else {
      closeModal();
    }
  }, [modalState]);

  useEffect(() => {
    if (token) {
      fetchProfile();
      CountSatatus();
      // NotificationData();
    }
  }, [token]);

  const fetchLogout = async () => {
    try {
      setLoaderFun(true);
      const token = localStorage.getItem("parqd_token");
      const deviceToken = localStorage.getItem("device_token");
      if (token) {
        await axios.get("/logout", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        localStorage.clear();
        // localStorage.setItem("device_token", deviceToken);
        setLoaderFun(false);
        closeModal();
        setUserToken(null);
        navigate("/");
      } else {
        setLoaderFun(true);
        Swal.fire({
          title: "Unauthorised User",
          imageUrl: somethingwrong,
          imageWidth: 300,
          imageHeight: 200,
          imageAlt: "Custom image",
        });
        closeModal();
        setLoaderFun(false);
      }
    } catch (error) {
      // Swal.fire({
      //   icon: "error",
      //   text: error.response ? error.response.data.message : error.message,
      // });
      setLoaderFun(true);
      Swal.fire({
        text: error.response ? error.response.data.message : error.message,
        imageUrl: invalidimg,
        imageWidth: 300,
        imageHeight: 200,
        imageAlt: "Custom image",
      });
      closeModal();
      setLoaderFun(false);
    }
  };

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("parqd_token");
      if (!token) return;
      const response = await axios.get("get_profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserToken(token);
      setProfile(response.data.result);
      console.log("profile-----", response.data.result);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const fetchDelete = async () => {
    setLoaderFun(true);
    try {
      const token = localStorage.getItem("parqd_token");
      const response = await axios.get("delete-account", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("delete account", response);

      setLoaderFun(false);

      setUserToken(null);
      localStorage.clear();

      // Show success message
      await Swal.fire({
        title: response?.data?.message,
        imageUrl: SuccessImg,
        imageWidth: 130,
        imageHeight: 113,
        imageAlt: "Success Image",
      });

      // Navigate to sign-up page after the alert is closed
      navigate("/sign_up");
    } catch (error) {
      console.error("Error deleting account:", error);
      // Optionally show an error message if deletion fails
      Swal.fire({
        title: error?.response?.data?.message,
        // text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    closeModal();
    setLoaderFun(false);
  };

  const ClearAllNotification = async () => {
    try {
      const token = localStorage.getItem("parqd_token");
      const response = await axios.delete("notification-clear", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Resp clear all", response.data);
      handleNotiifcation();
      await Swal.fire({
        title: "Success!",
        text: "Notification Deleted Successfully",
        icon: "success",
        confirmButtonText: "OK",
        willClose: () => {
          setNotifyDelete(false);
          setNotificationmenuPopup(true);
        },
      });
    } catch (error) {
      console.log("error", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to delete Notification. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const deleteNotifyConfirm = () => {
    setNotifyDelete(true);
    // setDelId(id);
    // handleDelete(id);
    // console.log("Dele", del);
  };

  const handleDelete = (type) => {
    console.log("delete type", type);
    if (type == 1) {
      ClearAllNotification();
    } else if (type == 2) {
      deleteNotifi();
    }
  };
  const deleteNotifi = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("parqd_token");
      const response = await axios.post(
        "notification-delete",
        { notification_id: delId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Resp clear all", response.data);
      // if(response.data.code == 200){
      setNotifyDelete(false);

      await Swal.fire({
        title: "Success!",
        text: "Notification Deleted Successfully",
        icon: "success",
        confirmButtonText: "OK",
        willClose: () => {
          setDelId();
          setNotificationmenuPopup(true);
        },
      });
      // } else {
      //   Swal.fire({
      //     title: "Error!",
      //     text: "Failed to delete Notification. Please try again.",
      //     icon: "error",
      //     confirmButtonText: "OK",
      //   });
      // }
    } catch (error) {
      console.log("error", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to delete Notification. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    setNotifyDelete(false);
    setLoading(false);
  };

  console.log("Noti", delId);
  useEffect(() => {
    if (modalState === "delete" || modalState === "logout") {
      document.body.classList.add("modal-open");

      // Create and append backdrop
      const backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade in";
      document.body.appendChild(backdrop);

      return () => {
        closeModal();
      };
    } else {
      closeModal();
    }
  }, [userToken, modalState]);

  const openModal = (modalType) => {
    setModalState(modalType);
  };

  const closeModal = () => {
    setModalState(null);
    document.body.classList.remove("modal-open");
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
  };

  const HomeItems =
    hostUser === 1 ? (
      <>
        <li
          className={
            useractive.pathname === "/hosthomes" ? "current_page_item" : ""
          }
        >
          <Link
            onClick={() => {
              setResponsivepop(true);
            }}
            to="/hosthomes"
          >
            Home
          </Link>
        </li>
      </>
    ) : (
      <>
        <li className={useractive.pathname === "/" ? "current_page_item" : ""}>
          <Link
            onClick={() => {
              setResponsivepop(true);
            }}
            to="/"
          >
            Home
          </Link>
        </li>
      </>
    );
  const menuItems =
    hostUser === 1 ? (
      <>
        <li
          className={
            useractive.pathname === "/my-listing" ? "current_page_item" : ""
          }
        >
          <Link
            onClick={() => {
              setResponsivepop(true);
            }}
            to="/my-listing"
          >
            My Listing
          </Link>
        </li>
        <li
          className={
            useractive.pathname === "/earning" ? "current_page_item" : ""
          }
        >
          <Link
            onClick={() => {
              setResponsivepop(true);
            }}
            to="/earning"
          >
            Earning
          </Link>
        </li>
      </>
    ) : (
      <>
        <li
          className={
            useractive.pathname === "/parking" ? "current_page_item" : ""
          }
        >
          <Link
            onClick={() => {
              setResponsivepop(true);
            }}
            to="/parking"
          >
            Spaces
          </Link>
        </li>
        {/* <li
          className={useractive.pathname === "/work" ? "current_page_item" : ""}
        >
          <Link  onClick={() => { setResponsivepop(true); }} to="/work">How It Works</Link>
        </li> */}
      </>
    );

  return (
    <>
      <div className="navbar-gray-yellow-transparent">
        <div className="nav-wrapper" id="nav-wrapper">
          <nav
            className="navbar navbar-static navbar-affix"
            data-spy="affix"
            style={{ zIndex: 9999 }}
          >
            <div className="container">
              <div className="navbar-header">
                {/* <button
                  type="button"
                  onClick={() => {
                    setResponsivepop(!responsePop);
                  }}
                  className="navbar-toggle collapse"
                >
                  {!responsePop ? (
                    <>
                      <span className="sr-only">Toggle navigation collapse</span>
                    </>
                  ) : (
                    <>
                      <span className="sr-only">Toggle navigation collapse</span>
                      <span className="icon-bar top-bar"></span>
                      <span className="icon-bar middle-bar"></span>
                      <span className="icon-bar bottom-bar"></span>
                    </>
                  )}
                </button> */}

                <button
                  type="button"
                  className={`navbar-toggle ${responsePop ? "collapsed" : ""} `}
                  onClick={() => {
                    setResponsivepop(!responsePop);
                  }}
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar top-bar"></span>
                  <span className="icon-bar middle-bar"></span>
                  <span className="icon-bar bottom-bar"></span>
                </button>

                <Link className="logo" to="/" rel="preload">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logo_parqd_small.png`}
                    alt="parqd"
                    loading="lazy"
                  />
                </Link>
              </div>
              <div
                id="navbar"
                className={`navbar-collapse ${responsePop ? "collapse" : ""}`}
                // className="navbar-collapse collapse"
              >
                {/* responsive header                                            */}

                <button
                  type="button"
                  className={`navbar-toggle  ${
                    responsePop ? "collapsed" : ""
                  } `}
                  onClick={() => {
                    setResponsivepop(!responsePop);
                  }}
                >
                  {/* <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar top-bar"></span>
                  <span className="icon-bar middle-bar"></span>
                  <span className="icon-bar bottom-bar"></span> */}
                </button>

                <ul className="nav navbar-nav">
                  {HomeItems}
                  <li
                    className={
                      useractive.pathname === "/aboutus"
                        ? "current_page_item"
                        : ""
                    }
                  >
                    <Link
                      onClick={() => {
                        setResponsivepop(true);
                      }}
                      to="/aboutus"
                    >
                      About Us
                    </Link>
                  </li>
                  {menuItems}
                  <li
                    className={
                      useractive.pathname === "/blogs"
                        ? "current_page_item"
                        : ""
                    }
                  >
                    <Link
                      to="/blogs"
                      onClick={() => {
                        setResponsivepop(true);
                      }}
                    >
                      Blogs
                    </Link>
                  </li>
                  <li
                    className={
                      useractive.pathname === "/contact"
                        ? "current_page_item"
                        : ""
                    }
                  >
                    <Link
                      to="/contact"
                      onClick={() => {
                        setResponsivepop(true);
                      }}
                    >
                      Contact Us
                    </Link>
                  </li>

                  {userToken ? (
                    <>
                      <li className="hasSub subforusermenu_acc useraccmenu_showafterlogin">
                        <a
                          className="useratag_acc"
                          onClick={() => setsubmenuPopup(!submenuPopup)}
                        >
                          <div className="useracc_namewithimg">
                            <span className="imgornamefirst_user">
                              {console.log("profile-----", profile)}
                              <img
                                src={
                                  profile.profile_image === null &&
                                  profile.profile_image === undefined
                                    ? `./images/favicon.png`
                                    : `${process.env.REACT_APP_PUBLIC_URL}${profile.profile_image}`
                                }
                                alt="User"
                                loading="lazy"
                              />
                            </span>
                            {profile.name}
                          </div>
                        </a>
                        <ul
                          className={`sub-menu submenufor_useracc_nav ${
                            submenuPopup ? "" : "show"
                          }`}
                        >
                          <div className="h-g-btn">
                            <li
                              className={
                                hostUser === 0 &&
                                guestURLs.includes(useractive.pathname)
                                  ? // useractive.pathname === "/"
                                    "active-btn current_page_item"
                                  : ""
                              }
                            >
                              <Link
                                to="/"
                                onClick={() => {
                                  localStorage.setItem("host_user", 0);
                                  setResponsivepop(true);
                                }}
                              >
                                Guest
                              </Link>
                            </li>

                            {profile.host_user === 1 ? (
                              <li
                                className={
                                  hostUser === 1 &&
                                  hostURLs.includes(useractive.pathname)
                                    ? "active-btn current_page_item"
                                    : ""
                                }
                                // className={
                                //   useractive.pathname === "/hosthomes" ? "current_page_item" : ""
                                // }
                              >
                                <Link
                                  to="/hosthomes"
                                  onClick={() => {
                                    localStorage.setItem("host_user", 1);
                                    setResponsivepop(true);
                                  }}
                                >
                                  Host
                                </Link>
                              </li>
                            ) : (
                              <li
                                className=""
                                // className={
                                //   useractive.pathname === "/hosthomes" ? "current_page_item" : ""
                                // }
                              >
                                <Link to="/welcomehost">Host</Link>
                              </li>
                            )}
                          </div>

                          {hostUser === 0 ? (
                            <>
                              <li
                                className={
                                  useractive.pathname === "/profile"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/profile"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Profile
                                </Link>
                              </li>

                              <li
                                className={
                                  useractive.pathname === "/welcomehost"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/welcomehost"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Become a Host
                                </Link>
                              </li>
                              <li
                                className={
                                  useractive.pathname === "/ownerbooking"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/ownerbooking"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  My Bookings
                                </Link>
                              </li>
                              <li
                                className={
                                  useractive.pathname === "/chatroom"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/chatroom"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Chat
                                </Link>
                              </li>
                              <li
                                className={
                                  useractive.pathname === "/Favorater"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/Favorater"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Favorite
                                </Link>
                              </li>
                              <li
                                className={
                                  useractive.pathname === "/helper"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/helper"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Help & Support
                                </Link>
                              </li>
                            </>
                          ) : (
                            <>
                              <li
                                className={
                                  useractive.pathname === "/profile"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/profile"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Profile
                                </Link>
                              </li>
                              {/* <li
                                className={
                                  useractive.pathname === "/HostBoking_history"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link to="/HostBoking_history">
                                  Booking History
                                </Link>
                              </li> */}
                              <li
                                className={
                                  useractive.pathname === "/chatroom"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/chatroom"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Chat
                                </Link>
                              </li>
                              <li
                                className={
                                  useractive.pathname === "/helper"
                                    ? "current_page_item"
                                    : ""
                                }
                              >
                                <Link
                                  to="/helper"
                                  onClick={() => {
                                    setResponsivepop(true);
                                  }}
                                >
                                  Help & Support
                                </Link>
                              </li>
                            </>
                          )}

                          <li>
                            <a
                              data-toggle="modal"
                              data-target="#user_deleteprofile_popup"
                              onClick={() => openModal("delete")}
                            >
                              Delete Account
                            </a>
                          </li>
                          <li>
                            <a
                              data-toggle="modal"
                              data-target="#user_logout_popup"
                              onClick={() => openModal("logout")}
                            >
                              Log Out
                            </a>
                          </li>
                        </ul>
                      </li>

                      <li className="hasSub menufornotification">
                        <Link
                          to="#"
                          className="belliconfornotify"
                          onClick={() => handleNotiifcation()}
                          onMouseEnter={NotificationData}
                        >
                          <i className="fa fa-bell" aria-hidden="true"></i>
                          {CountStatus?.is_read == 0 ? (
                            <span className="notifycountspan">
                              {/* {CountStatus?.is_read} */}
                            </span>
                          ) : (
                            ""
                          )}
                        </Link>
                        <ul
                          className={`sub-menu menufornotificationdiv ${
                            notificationmenuPopup ? "" : "show responsive-style"
                          }`}
                        >
                          <li
                            className="notification_navnew"
                            style={{ background: "rgb(255, 204, 0)" }}
                          >
                            {/* Clear all notification */}
                            <a
                              className="notify_atag"
                              onClick={() => deleteNotifyConfirm()}
                            >
                              <div className="notification_parqddiv">
                                <div
                                  className="notify_text"
                                  // style={{ textAlign:"end" }}
                                >
                                  <h3 style={{ textAlign: "end" }}>
                                    Clear All
                                  </h3>
                                  <p>
                                    {/* {values.description} for Booking Date:{" "}
                                      {values.booking_date_time} */}
                                  </p>
                                </div>
                              </div>
                            </a>
                          </li>
                          {/* <li className="notification_navnew nonotification_avail"> */}
                          {notiLoad ? (
                            <>
                              <div style={{ marginTop: "30%" }}>
                                <Loader />
                              </div>
                            </>
                          ) : NotificationResult.length === 0 ? (
                            <li className="notification_navnew">
                              {/* No Notification Available */}
                              <a className="notify_atag">
                                <div className="notification_parqddiv">
                                  <div className="notifyicon">
                                    {" "}
                                    {/* <img src="images/notify_icon.png" />{" "} */}
                                    {/* <img
                                      src={`${process.env.PUBLIC_URL}/images/notify_icon.png`}
                                    />{" "} */}
                                  </div>
                                  <div
                                    className="notify_text"
                                    style={{ margin: "116px 0px 0px 113px" }}
                                  >
                                    <h3 style={{ textAlign: "center" }}>
                                      No Notification
                                    </h3>
                                    <p>
                                      {/* {values.description} for Booking Date:{" "}
                                      {values.booking_date_time} */}
                                    </p>
                                    {/* <p>
                                      Booking Date: {values.booking_date_time}
                                    </p> */}
                                  </div>
                                  {/* <div className="notifytime">
                                    <h3>9:00AM</h3>
                                  </div> */}
                                </div>
                              </a>
                            </li>
                          ) : (
                            NotificationResult.map((values, index) => (
                              <li
                                className="notification_navnew"
                                key={index}
                                style={{ width: "auto", overflow: "auto" }}
                              >
                                {/* No Notification Available */}
                                <a className="notify_atag">
                                  <div
                                    className="each-notification"
                                    style={{ display: "flex" }}
                                  >
                                    <div className="notification_parqddiv">
                                      <div className="notifyicon">
                                        {" "}
                                        {/* <img src="images/notify_icon.png" />{" "} */}
                                        <img
                                          src={`${process.env.PUBLIC_URL}/images/notify_icon.png`}
                                        />{" "}
                                      </div>
                                      <div className="notify_text">
                                        <h3>{values.title}</h3>
                                        <p>
                                          {values.description}
                                          {/* {values.booking_date_time} */}
                                        </p>
                                        {values.booking_date_time && (
                                          <p>
                                            Booking Date:{" "}
                                            {values.booking_date_time}
                                          </p>
                                        )}
                                      </div>
                                      {/* <div className="notifytime">
                                    <h3>9:00AM</h3>
                                  </div> */}
                                    </div>
                                    <div>
                                      <button
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                        }}
                                        onClick={() => {
                                          setDelId(values.id);
                                          deleteNotifyConfirm();
                                        }}
                                      >
                                        <i class="fa-solid fa-xmark"></i>
                                      </button>
                                    </div>
                                  </div>
                                </a>
                              </li>
                            ))
                          )}
                        </ul>
                      </li>
                    </>
                  ) : (
                    <>
                      <li
                        className={
                          useractive.pathname === "/login"
                            ? "current_page_item"
                            : ""
                        }
                      >
                        <Link
                          to="/login"
                          onClick={() => {
                            setResponsivepop(true);
                          }}
                        >
                          Login
                        </Link>
                      </li>
                      <li
                        className={
                          useractive.pathname === "/sign_up"
                            ? "current_page_item"
                            : ""
                        }
                      >
                        <Link
                          to="/sign_up"
                          onClick={() => {
                            setResponsivepop(true);
                          }}
                        >
                          Sign Up
                        </Link>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* Logout Modal */}
      <div
        className={`modal fade verifymodal_main  ${
          modalState === "logout" ? "in" : ""
        }`}
        // className="modal fade verifymodal_main in"
        id="user_logout_popup"
        role="dialog"
        style={{
          display: modalState === "logout" ? "block" : "none",
          zIndex: 9999,
        }}
      >
        <div className="modal-dialog mdldlg_verify">
          <div className="modal-content mdlcont_verifydiv">
            <div className="modal-body mdlbdl_verify-your">
              <button
                type="button"
                className="close verifypopup_closebtn"
                data-dismiss="modal"
              >
                &times;
              </button>

              <a className="close verifypopup_closebtn" onClick={closeModal}>
                ×
              </a>
              {LoaderFun ? (
                <Loader />
              ) : (
                <div className="mainverifydiv">
                  <div className="verifytext">
                    <h3>Logout</h3>
                    <p>Are you sure you want to log out?</p>
                  </div>

                  <img
                    className="delete"
                    src={`${process.env.PUBLIC_URL}/images/logout.png`}
                    alt="Logout"
                    loading="lazy"
                  />
                  <div className="verify_next_resentbtn">
                    <button
                      type="button"
                      className="next_verifybtn"
                      onClick={fetchLogout}
                    >
                      Logout
                    </button>
                  </div>
                  <div className="verify_next_resentbtn">
                    <button
                      type="button"
                      className="resendbtn_verify"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Account Modal */}
      <div
        className={`modal fade verifymodal_main ${
          modalState === "delete" ? "in" : ""
        }`}
        id="user_deleteprofile_popup"
        role="dialog"
        style={{
          display: modalState === "delete" ? "block" : "none",
          zIndex: 9999,
        }}
      >
        <div className="modal-dialog mdldlg_verify">
          <div className="modal-content mdlcont_verifydiv">
            <div className="modal-body mdlbdl_verify-your">
              <a className="close verifypopup_closebtn" onClick={closeModal}>
                ×
              </a>
              {LoaderFun ? (
                <Loader />
              ) : (
                <div className="mainverifydiv">
                  <div className="verifytext">
                    <h3>Delete Account</h3>
                    <p>Are you sure you want to delete your account?</p>
                  </div>
                  <img
                    className="delete"
                    src={`${process.env.PUBLIC_URL}/images/delete.png`}
                    alt="Delete Account"
                    loading="lazy"
                  />
                  <div className="verify_next_resentbtn">
                    <button
                      type="button"
                      className="next_verifybtn"
                      onClick={fetchDelete}
                    >
                      Delete
                    </button>
                  </div>
                  <div className="verify_next_resentbtn">
                    <button
                      type="button"
                      className="resendbtn_verify"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Notification Modal */}
      <div
        className={`modal fade verifymodal_main ${notifyDelete ? "in" : ""}`}
        id="user_deleteprofile_popup"
        role="dialog"
        style={{
          display: notifyDelete ? "block" : "none",
          zIndex: 9999,
        }}
      >
        <div className="modal-dialog mdldlg_verify">
          <div className="modal-content mdlcont_verifydiv">
            <div className="modal-body mdlbdl_verify-your">
              <a
                className="close verifypopup_closebtn"
                onClick={() => setNotifyDelete(false)}
              >
                ×
              </a>

              <div className="mainverifydiv">
                <div className="verifytext">
                  <h3>Delete Notification</h3>
                  <p>Are you sure you want to delete notification?</p>
                </div>
                <img
                  className="delete"
                  src={`${process.env.PUBLIC_URL}/images/delete.png`}
                  alt="Delete Account"
                  loading="lazy"
                />
                <div className="verify_next_resentbtn">
                  <button
                    type="button"
                    className="next_verifybtn"
                    onClick={() => {
                      if (delId == "") {
                        handleDelete(1);
                      } else {
                        handleDelete(2);
                      }
                    }}
                    disabled={loading ? true : false}
                  >
                    {loading ? "Please wait..." : "Delete"}
                  </button>
                </div>
                <div className="verify_next_resentbtn">
                  <button
                    type="button"
                    className="resendbtn_verify"
                    onClick={() => setNotifyDelete(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
